import * as urlsApi from "../../utils/contants/urlsApi";

import { buildErroHandleItems, buildPagination } from "../../helpers/sharedHelpers";
import { put, select, takeLatest } from "redux-saga/effects";

import API from "../../utils/API";
import { Types as MessageTypes } from "../ducks/messages";
import { Types } from "../ducks/manager";
import { history } from "../../utils/routes";
import * as routes from "../../utils/contants/urls";

function getProfileApi() {
  return API.get(
    `${urlsApi.REQUEST_PROFILES}`
  )
    .then(res => res.data)
    .catch(error => { throw error });
}


function* getProfileList() {
  try {
    const { lista } = yield getProfileApi();
    yield put({
      type: Types.PROFILES_SUCCESS,
      profilesList: lista
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_FAIL, messages });
  }
}
function deleteUserApi(id) {
  return API.delete(`${urlsApi.DELETE_MANAGER}/${id}`)
    .then((res) => res.data)
    .catch((error) => { throw error })
}
function* deleteUser({ id }) {
  try {
    yield deleteUserApi(id)

    yield put({ type: Types.USER_DELETE_SUCCESS, id });
    yield getUsersList();
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.USER_DELETE_FAIL, error });
  }
}

function getUsersApi() {
  return API.get(
    `${urlsApi.REQUEST_USERS}`
  )
    .then(res => res.data)
    .catch(error => { throw error });
}

function* getUsersList() {
  try {
    const usuarios = yield getUsersApi();
    yield put({
      type: Types.PROFILES_USERS_SUCCESS,
      users: usuarios
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_USERS_FAIL, messages });
  }
}

function* getPerfilJobsList() {
  try {
    const perfilJobs = yield GetPerfilJobsApi();
    yield put({
      type: Types.PROFILES_GET_PERFIL_JOBS_SUCCESS,
      perfilJobs:{data: perfilJobs,idPerfil:''}
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_GET_PERFIL_JOBS_FAIL, messages });
  }
}


const updatePerfilUserApi = param =>

  API.put(urlsApi.REQUEST_PROFILES, param)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });


function* updatePerfilUser(payload) {
  try {
    const param = { IdPerfil: payload.payload.idNewPerfil, IdUser: payload.payload.userId };

    const usuarios = yield updatePerfilUserApi(param);
    yield put({
      type: Types.PROFILES_USER_UPDATE_SUCCESS,
      users: usuarios
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_USER_UPDATE_FAIL, messages });
  }
}


const updatePerfilJobsApi = param =>

  API.put(urlsApi.UPDATE_PERFIL_JOBS, param)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });


function GetPerfilJobsApi() {
  return API.get(
    `${urlsApi.GET_PERFIL_JOBS}`
  )
    .then(res => res.data)
    .catch(error => { throw error });
}

function* updatePerfilJobs(payload) {
  try {
    const param = { idPerfil: payload.payload.idPerfil, idCargo: payload.payload.idCargo, remover:payload.payload.remover  };
    yield updatePerfilJobsApi(param);
    const dd = payload.payload.idPerfil;
    const jobsByProfiles =  yield GetPerfilJobsApi() ;
    yield put({
      type: Types.PROFILES_JOBS_UPDATE_SUCCESS,
      perfilJobs:{data: jobsByProfiles,idPerfil:payload.payload.idPerfil}
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_JOBS_UPDATE_FAIL, messages });
  }
}






function getProfilePermissionsApi(id) {
  return API.get(
    `${urlsApi.REQUEST_PROFILEPERMISSIONS}?Id=${id}`
  )
    .then(res => res.data)
    .catch(error => { throw error });
}

function* getProfilePermissionsList(payload) {
  try {
    const profilepermissions = yield getProfilePermissionsApi(payload.payload);
    yield put({
      type: Types.PROFILES_PERMISSIONS_SUCCESS,
      profilepermissionsSelected: profilepermissions
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_PERMISSIONS_FAIL, messages });
  }
}




const editPermissionProfileApi = param =>

  API.put(urlsApi.EDIT_PERMISSIONS_PROFILES, param)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });


function* editPermissionProfile(payload) {
  try {
    const param = { id: payload.payload.id, permission: payload.payload.enabled };
    const profilepermissions = yield editPermissionProfileApi(param);
    yield put({
      type: Types.PROFILES_PERMISSIONS_SUCCESS,
      profilepermissionsSelected: profilepermissions
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_PERMISSIONS_FAIL, messages });
  }
}



const createUserApi = user =>

  API.post(urlsApi.CREATE_MANAGER, user)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });


function* createUser(payload) {
  try {
    const user = {
      nome: payload.payload.name,
      email: payload.payload.email,
      pessoa_Id: payload.payload.pessoaId,
      perfilAcesso_Id: payload.payload.profile,
      podeEditarPerfil: payload.payload.isAdministrador ? 1 : 0,
      podeAcessarPlug: payload.payload.canAcessPlug ? 1 : 0,
      podeAcessarTalentos: payload.payload.canAcessTalentos ? 1 : 0
    };
    const { lista } = yield createUserApi(user);
    yield put({
      type: Types.USERS_SUCCESS,
    });
    history.push(`${routes.USERS}`);
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_CREATE_FAIL, messages });
  }
}


const createProfileApi = nome =>

  API.post(urlsApi.CREATE_PROFILES, nome)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });


function* createProfile(payload) {
  try {
    const nome = { nome: payload.payload.name };
    const { lista } = yield createProfileApi(nome);
    yield put({
      type: Types.PROFILES_CREATE_SUCCESS,
      profiles: lista
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_CREATE_FAIL, messages });
  }
}




const enableStageProfileApi = param =>

  API.put(urlsApi.EDIT_ACCESS_STAGE_PROFILES, param)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });

const enablePlugProfileApi = param =>
  API.put(urlsApi.CHANGE_ACESS_PLUG_MANAGER, param)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });

function* enablePlugProfile(payload) {
  try {
    const param = { id: payload.payload.id, PodeAcessarPlug: payload.payload.enabled };
    yield enablePlugProfileApi(param);
    yield put({
      type: Types.PROFILES_ENABLE_PLUG_SUCCESS,
      users: yield getUsersList()
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_ENABLE_PLUG_FAIL, messages });
  }
}

const enableTalentosProfileApi = param =>
  API.put(urlsApi.CHANGE_ACESS_TALENTOS_MANAGER, param)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });

function* enableTalentosProfile(payload) {
  try {
    const param = { id: payload.payload.id, PodeAcessarTalentos: payload.payload.enabled };
    yield enableTalentosProfileApi(param);
    yield put({
      type: Types.PROFILES_ENABLE_TALENTOS_SUCCESS,
      users: yield getUsersList()
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_ENABLE_TALENTOS_FAIL, messages });
  }
}

const enableManagerProfileApi = param =>
  API.put(urlsApi.CHANGE_ACESS_USER_MANAGER, param)
    .then(res => res.data)
    .catch(error => {
      throw error;
    });

function* enableManagerProfile(payload) {
  try {
    const param = { id: payload.payload.id, PodeEditarPerfil: payload.payload.enabled };
    yield enableManagerProfileApi(param);
    yield put({
      type: Types.PROFILES_ENABLE_MANAGER_SUCCESS,
      users: yield getUsersList()
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_ENABLE_MANAGER_FAIL, messages });
  }
}

function* enableStageProfile(payload) {
  try {
    const param = { id: payload.payload.id, PodeEditarEtapas: payload.payload.enabled };
    const profilepermissions = yield enableStageProfileApi(param);
    yield put({
      type: Types.PROFILES_ENABLE_STAGE_SUCCESS,
      profilepermissionsSelected: profilepermissions
    });
  } catch (error) {
    const messages = buildErroHandleItems(error.response)
    yield put({ type: MessageTypes.MESSAGE_PUBLICATION, messages });
    yield put({ type: Types.PROFILES_ENABLE_STAGE_FAIL, messages });
  }
}

export function* watcherSaga() {
  yield takeLatest(Types.PROFILES_REQUEST, getProfileList);
  yield takeLatest(Types.PROFILES_USERS_REQUEST, getUsersList);
  yield takeLatest(Types.USERS_REQUEST, createUser);
  yield takeLatest(Types.PROFILES_USER_UPDATE_REQUEST, updatePerfilUser);
  yield takeLatest(Types.PROFILES_PERMISSIONS_REQUEST, getProfilePermissionsList);
  yield takeLatest(Types.PROFILES_EDIT_PERMISSIONS_REQUEST, editPermissionProfile);
  yield takeLatest(Types.PROFILES_CREATE_REQUEST, createProfile);
  yield takeLatest(Types.PROFILES_ENABLE_STAGE_REQUEST, enableStageProfile);
  yield takeLatest(Types.PROFILES_ENABLE_PLUG_REQUEST, enablePlugProfile);
  yield takeLatest(Types.PROFILES_ENABLE_TALENTOS_REQUEST, enableTalentosProfile);
  yield takeLatest(Types.USER_DELETE_REQUEST, deleteUser);
  yield takeLatest(Types.PROFILES_ENABLE_MANAGER_REQUEST, enableManagerProfile);
  yield takeLatest(Types.PROFILES_JOBS_UPDATE_REQUEST, updatePerfilJobs);
  yield takeLatest(Types.PROFILES_GET_PERFIL_JOBS_REQUEST, getPerfilJobsList);
  

}
